import { createContext, PropsWithChildren, useEffect, useState } from 'react';
import { Box, defineStyle } from '@chakra-ui/react';
import { CratIconAnimated } from '../components/CratIconAnimated/CratIconAnimated';

const LoaderContext = createContext(undefined);

const globalLoaderContainerStyle = defineStyle({
  position: 'fixed',
  top: '0',
  left: '0',
  width: '100vw',
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: '2147483640',
  transition: 'all 0.5s ease-out',
  backgroundColor: 'bgColor.100',
} as const);

export const LoaderProvider = ({ children }: PropsWithChildren) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loading = setTimeout(() => setIsLoading(false), 4000);
    return () => clearTimeout(loading);
  }, []);

  return (
    <LoaderContext.Provider value={undefined}>
      {isLoading && (
        <Box {...globalLoaderContainerStyle}>
          <CratIconAnimated sx={{ width: { xs: 175, md: 325 } }} />
        </Box>
      )}

      {children}
    </LoaderContext.Provider>
  );
};

export const WithLoader = ({ children }: PropsWithChildren) => {
  // if (!IS_PRODUCTION) {
  //   // eslint-disable-next-line react/jsx-no-useless-fragment
  //   return <>{children}</>;
  // }

  return <LoaderProvider>{children}</LoaderProvider>;
};
